import AddGdDlysjgClientParamModal from './add-gd-dlysjg-client-param-modal.vue'
export default AddGdDlysjgClientParamModal
